import { LazyLoad } from 'app/utils';

export const BannerSortPage = LazyLoad(
  () => import('./index'),
  (module) => module.BannerSortPage,
);
